import { Storage, STORAGE_KEYS } from "../../utils/store";
import { initHttpClient } from "../http-client";
import { AUTH_EVENT_TYPE, emitAuth, addHandler } from "./auth-channel";

class AuthEngine {
    #httpClient;

    static #lockStorageKey = 'refresh_lock';
    
    constructor() {
        this.#httpClient = initHttpClient();
    }

    login(username, password) {
        return this.#httpClient.post('/login/', {
            data: { username, password },
            headers: { 'Accept': 'application/json' }
        })
        .then(tokens => {
            Storage.store(STORAGE_KEYS.JWT, tokens.access, true);
            Storage.store(STORAGE_KEYS.JWT_RENEW, tokens.refresh);
            
            const redirect = Storage.get(STORAGE_KEYS.REDIRECT_AFTER_LOGIN);
        
            if(redirect) {
                window.location.href = redirect;
            } else {
                window.location.reload();
            }
        })
        .catch(this.#httpClient.handleRejection.bind(this.#httpClient));
    }

    refresh(refreshToken) {
        if (!refreshToken) {
            return Promise.resolve(false);
        }

        return !this.#aquireLock() 
            ? this.#waitForRefresh() 
            : this.#httpClient.post('/login/refresh', {
                data: { "refresh": refreshToken },
                headers: {
                    'Accept': 'application/json'
                }
            }).then(tokens => {
                Storage.store(STORAGE_KEYS.JWT, tokens.access, true);
                Storage.store(STORAGE_KEYS.JWT_RENEW, tokens.refresh);
                
                return true;
            }).catch(err => {
                if (err.status === 401) {
                    // Une session expirée est attendue lors de la reconnexion automatique.
                    Storage.clear(STORAGE_KEYS.JWT);
                    Storage.clear(STORAGE_KEYS.JWT_RENEW);
                    Storage.clear(STORAGE_KEYS.USER);
                    Storage.clear(STORAGE_KEYS.USER_DETAILS);
                } else {
                    this.#httpClient.handleRejection(err);
                }

                return false;
            }).finally(() => this.#releaseLock());
    } 

    logout() {
        Storage.clear(STORAGE_KEYS.JWT);
        Storage.clear(STORAGE_KEYS.JWT_RENEW);

        window.location.reload();
    }

    #waitForRefresh(timeout = 5000) {
        return new Promise((res) => {
            const timer = setTimeout(() => res(false), timeout);

            addHandler(({ data: msg }) => {
                if (msg.type === AUTH_EVENT_TYPE.REFRESH) {
                    clearTimeout(timer);
                    res(true);
                }
            })
        });
    }

    // Pour éviter que tout les onglets refresh le token
    // en même temps
    #aquireLock() {
        const lock = Storage.get(AuthEngine.#lockStorageKey);

        if (lock) { return false; }

        Storage.store(AuthEngine.#lockStorageKey, Date.now(), true);

        return true;
    }

    #releaseLock() {
        Storage.clear(AuthEngine.#lockStorageKey);
    }
}

export default AuthEngine;
